import { AfterContentInit, Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { finalize } from 'rxjs/operators';

import { ErrorHandlerService, AuthenticationService, NotyService, EnterpriseService, AppService } from '@app/services';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-auth-password-new',
  templateUrl: './auth-password-new.component.html',
  styleUrls: ['../auth.scss', './auth-password-new.component.scss'],
  standalone: false
})
export class AuthPasswordNewComponent implements OnInit, AfterContentInit {
  form!: UntypedFormGroup;
  isLoading = false;
  wasSent = false;
  secondChance = false;

  private navigationState: { [k: string]: any };

  constructor(
    public route: ActivatedRoute,
    public appService: AppService,
    private formBuilder: UntypedFormBuilder,
    public enterpriseService: EnterpriseService,
    private authenticationService: AuthenticationService,
    private errorHandlerService: ErrorHandlerService,
    private notyService: NotyService,
    private translateService: TranslateService,
    private router: Router
  ) {
    this.form = this.formBuilder.group({ email: this.route.snapshot.queryParams.email || '' });
    this.navigationState = router.getCurrentNavigation()?.extras.state || {};
  }

  ngOnInit() {
    this.authenticationService.logout().subscribe();
  }

  ngAfterContentInit() {
    if (this.navigationState?.fromAuthRegister && this.form.get('email').value) {
      history.replaceState({}, ''); // Clear fromAuthRegister before reload to avoid duplicate recovery email
      this.sendPasswordConfirmation();
    }
  }

  sendSecondChance() {
    this.secondChance = true;
    this.sendPasswordConfirmation();
  }

  sendPasswordConfirmation() {
    this.isLoading = true;
    this.form.markAllAsTouched();

    this.authenticationService
      .sendResetPasswordConfirmation(this.form.get('email').value)
      .pipe(finalize(() => (this.isLoading = false)))
      .subscribe({
        next: () => {
          this.notyService.success(this.translateService.instant('notyService.emailSentResetPassword'));
          // this.form.get('email').setValue('');

          this.wasSent = true;
        },
        error: error => this.errorHandlerService.handleValidation(this.form, error)
      });
  }

  isOutlookEmail(email: string) {
    return !!(email || '').match(/(@hotmail\.com)|(@outlook\.com)/);
  }
}
